import React from "react";
import PropTypes from 'prop-types';
import { ToggleControl } from '@wordpress/components';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

class TextareaInput extends Base {
	input() {
		const { inputValue } = this.props;
		
		return(
			<ToggleControl checked={ inputValue } onChange={ ( newValue ) => {
				this.onChange( newValue );
			} } />
		);
	}
}


TextareaInput.propTypes = {
	inputValue: PropTypes.bool,
};

export default withInput( TextareaInput );
